module.exports = "<button type=\"submit\" class=\"btn\"\n  [ngClass]=\"type\">\n  {{ label }}\n</button>";